module.exports = __webpack_public_path__ + "static/logo-blue-8baf8268377206a7d4d849f3253a1692.png";